import Vue from 'vue'
import DPov from "dpov-vue-library"; // "dpov-vue-components" is aliased in quasar.conf.js

window.log = new DPov.Logger({level:3, usePrefix: false, colorized: true})

Vue.use(DPov)
